import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { BrowserRouter as Router } from 'react-router-dom'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import createLogger from 'redux-logger'
import App from './components/App'

// Prepare the coursenum for initial store state
const pathArray = window.location.pathname.split('/')
const coursenum = pathArray[3]

const defaultState = {
  coursenum,
  certInfo: {
    header: 'Certificate of Completion',
    preamble: 'This is to certify that',
    reason: 'has completed the course',
    award: 'MyEducator Basics',
    image: '',
    imageName: '',
    imageLoaded: false, // true if image is loaded from server or from file upload input
    selectedAssessments: [],
    selectedChapters: [],
    passingScore: '50',
    retrievedEditData: false,
    newUploadedImage: false, // true if image is loaded from file upload input
    description: '',
  },
  assessments: {},
  chapters: {
    id: '',
    title: '',
    chapterChoices: [],
  },
  finished: false,
  errors: [],
}

export const rootReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'UPDATE_CERT_INFO':
      return {
        ...state,
        certInfo: { ...state.certInfo, ...action.certInfo },
      }
    case 'UPDATE_ASSESSMENTS':
      return {
        ...state,
        assessments: action.assessments,
      }
    case 'PUSH_ASSESSMENTS':
      return {
        ...state,
        certInfo: {
          ...state.certInfo,
          selectedAssessments: action.selectedAssessments,
        },
      }
    case 'UPDATE_CHAPTERS':
      return {
        ...state,
        chapters: action.chapters,
      }
    case 'PUSH_CHAPTERS':
      return {
        ...state,
        certInfo: {
          ...state.certInfo,
          selectedChapters: action.selectedChapters,
        },
      }
    case 'PUSH_PASSING_SCORE':
      return {
        ...state,
        certInfo: { ...state.certInfo, passingScore: action.passingScore },
      }
    case 'FINISH_CERTIFICATE':
      return {
        ...state,
        finished: true,
      }
    case 'SET_ERRORS':
      return {
        ...state,
        errors: action.errors,
      }
    default:
      return state
  }
}

const middlewares =
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunk)
    : applyMiddleware(thunk, createLogger())
let appStore = compose(middlewares)(createStore)(rootReducer)

export let startCertificatesApp = coursenum => {
  ReactDOM.render(
    <Router>
      <Provider store={appStore}>
        <App coursenum={coursenum} />
      </Provider>
    </Router>,
    document.getElementById('app')
  )
}
